import React from "react";

export const FormLabel: React.FC<{ label: string }> = ({ label, children }) => {
  return (
    <label className="flex flex-col items-start gap-4">
      <span className="font-bold">{label}</span>
      {children}
    </label>
  );
};
